import { FormControl, InputLabel, Select, TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import "../../css/NextContentModule.scss";
import {
  getNextaModuleDetails,
  getNextaModulecardDetails,
  getBusinessRulesModuleManager,
  getNextModuleBrandsCampaigns,
} from "../../services/apis";
import NextModuleGenericCard from "../NextModuleGenericCard";
import MenuItem from "@mui/material/MenuItem";
import CircularProgressBar from "../../utils/CircularProgressBar";

import CustomModal from "../../components/CustomModal";
import AssociateModuleModal from "./AssociatedModuleModal";
import CrossIcon from "../../images/CrossIcon.svg";
import { showErrorToast } from "../toastComponent/ToastComponent";

const NextContentModuleModal = (props) => {
  const {
    deckData,
    handleSelectNextModalHide,
    brands,
    campaign,
    market,
    categoryList,
    setShowAssociateModal,
    showAssociateModal,
    contentModules,
    setContentModules,
    linkedMMModules,
    setLinkedModule,
    setLinkedMMModules,
    linkedSearchExpression,
  } = props;
  const [nextModuleCategoryList, setNextModuleCategoryList] = useState([]);
  const [searchedText, setSearchedText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [nextModuleList, setNextModuleList] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const [userSelctedModuleList, setUserSelctedModuleList] = useState([]);
  const [selectedNextModuleList, setSelectedNextModuleList] = useState([]);
  const [checked, setChecked] = useState(false);
  // const [showAssociateModal, setShowAssociateModal] = useState(false);
  const [associatedModulecards, setAssociatedModulecards] = useState([]);
  const [conflictList, setConflictList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [payloadObject, setPayloadObject] = useState({});
  const [editModulelistFlag, setEditModulelistFlag] = useState(false);
  const [closeWarningFlag, setCloseWarningFlag] = useState(false);
  const [resetFlag, setResetFlag] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);

  useEffect(() => {
    // getNextModuleList();
    getDefaultCardsList();
    getNextModuleBrandDetails();
  }, [flag]);

  const getNextModuleBrandDetails = () => {
    getNextModuleBrandsCampaigns((response, err, errorCode) => {
      if (err) {
        showErrorToast('No respone found. Please try again.');
      } else {
        const brandName = getBrandAndMarketCamp("brand");
        const id = response.data.filter((f) => f.brandName === brandName)[0][
          "brandId"
        ];
        getNextModuleList(id);
      }
    });
  };

  const getNextModuleList = (id) => {
    getNextaModuleDetails(id, (response, err, errorCode) => {
      if (err) {
        showErrorToast('No respone found. Please try again.');
      } else {
        setNextModuleCategoryList(response.data);
      }
    });
  };

  const getModulesCardDetails = () => {
    setSearchFlag(true);
    const data = {
      brandName: getBrandAndMarketCamp("brand"),
      claimCategoryArray: getSlectedClaimCategory(),
      moduleNameArray: searchedText ? [searchedText] : [],
      campaign: "",
      //campaign: getBrandAndMarketCamp("camp"),
    };
    const proceedSearchExpressionPayload = {
      brand_name: getBrandAndMarketCamp("brand"),
      claim_category: selectedCategory,
      module_name: searchedText ? [searchedText] : [],
      asset_name: [],
      core_claim: [],
    };
    setPayloadObject({ ...proceedSearchExpressionPayload });
    if (
      (searchedText == null || searchedText.trim() == "") &&
      selectedCategory == ""
    ) {
      showErrorToast('Please provide atleast one input');
      return;
    }
    setIsloading(true);
    getNextaModulecardDetails(data, (response, err, errorCode) => {
      if (err) {
        setIsloading(false);
      } else {
        setIsloading(false);
        setNextModuleList(response.data);
        setSelectedNextModuleList([]);
        setChecked(false);
        setCloseWarningFlag(false);
        setResetFlag(false);
      }
    });
  };

  const getDefaultCardsList = () => {
    const data = {
      brandName: getBrandAndMarketCamp("brand"),
      claimCategoryArray: !resetFlag
        ? linkedSearchExpression?.claim_category
          ? [linkedSearchExpression?.claim_category]
          : []
        : getSlectedClaimCategory(),
      moduleNameArray: !resetFlag
        ? linkedSearchExpression?.module_name?.length > 0
          ? linkedSearchExpression?.module_name
          : []
        : searchedText
        ? [searchedText]
        : [],
      campaign: "",
      //campaign: getBrandAndMarketCamp("camp"),
    };
    setIsloading(true);
    const proceedSearchExpressionPayload = {
      brand_name: getBrandAndMarketCamp("brand"),
      claim_category: selectedCategory,
      module_name: searchedText ? [searchedText] : [],
      asset_name: [],
      core_claim: [],
    };
    setPayloadObject({ ...proceedSearchExpressionPayload });
    getNextaModulecardDetails(data, (response, err, errorCode) => {
      if (err) {
        setIsloading(false);
      } else {
        setIsloading(false);
        setNextModuleList(response.data);
        if (!resetFlag) {
          previousCardSelected(response.data);
        }
      //  console.log("after refersh", nextModuleList);
      }
    });
  };

  const previousCardSelected = (nextModuleList) => {
    const selectedCards = {};
    if (linkedMMModules.length > 0 && contentModules.length > 0) {
      setEditModulelistFlag(true);
      setCloseWarningFlag(true);
      for (var i = 0; i < linkedMMModules.length; i++) {
        if (
          linkedMMModules[i].parent_module &&
          contentModules.includes(linkedMMModules[i].moduleid)
        ) {
          selectedCards[linkedMMModules[i].moduleid] =
            linkedMMModules[i].moduleid;
        }
      }
      const filterOut = nextModuleList.filter(
        (f) => f.id === selectedCards[f.id]
      );
      setSelectedNextModuleList([...filterOut]);
    //  console.log(filterOut, "prev selection");
      setSearchedText(
        linkedSearchExpression?.module_name?.length > 0
          ? linkedSearchExpression?.module_name[0]
          : ""
      );
      setSelectedCategory(
        linkedSearchExpression?.claim_category !== ""
          ? linkedSearchExpression?.claim_category
          : ""
      );
    }
  };

  const getSlectedClaimCategory = () => {
    let finalCategory = [];
    if (selectedCategory?.length > 0) {
      finalCategory?.push(selectedCategory);
    }
    return finalCategory;
  };

  const getBrandAndMarketCamp = (type) => {
    let obj = {
      brand: "",
      market: "",
      campaign: "",
    };
    if (type === "brand") {
      let brandName = brands.find((item) => item._id === deckData.brand);
      return (obj.brand = brandName?.name);
    } else if (type === "market") {
      let marketName = market.find((item) => item._id === deckData.market);
      return (obj.market = marketName?.name);
    } else if (type === "campaign") {
      let filterdCampaign = brands.filter(
        (item) => item?._id == deckData?.brand
      )[0]?.campaigns;
      if (filterdCampaign && filterdCampaign.length > 0) {
        let compainName = filterdCampaign?.find(
          (item) => item?._id == deckData?.campaign
        );
        return (obj.campaign = compainName?.name);
      }
    }
  };

  const resetSearchResult = () => {
    setResetFlag(true);
    setSearchedText("");
    setSelectedCategory("");
    setNextModuleList([]);
    setSelectedNextModuleList([]);
    setFlag((prevProps) => !prevProps);
    setCloseWarningFlag(false);
    setChecked(false);
    setSearchFlag(false);
  };

  const handleEnterKeypress = (event) => {
    //it triggers by pressing the enter key
    if (event.key === "Enter") {
      getModulesCardDetails();
    }
  };
  const selectedCardHandler = (card) => {
    const findCard = selectedNextModuleList?.findIndex(
      (item) => item.id === card.id
    );
    if (findCard !== -1) {
      const filteredCard = selectedNextModuleList?.filter(
        (f) => f.id !== card.id
      );
      setSelectedNextModuleList(filteredCard);
      if (selectedNextModuleList.length < 2) {
        setChecked(false);
      }
    } else {
      setSelectedNextModuleList([...selectedNextModuleList, card]);
    }
  };
  const handleChangeCategory = (event) => {
    setSelectedCategory(event.target.value);
  };

  let filteredCanotExistModule = [];
  let WarningMsgOnSelected = [];
  selectedNextModuleList?.forEach((f) => {
    f?.cannotExistRuleList?.find((l) => {
      if (!filteredCanotExistModule.includes(l)) {
        filteredCanotExistModule.push(l);
      }
      let foundInSelected = selectedNextModuleList?.find(
        (Next) => Next.id === l
      );

      if (foundInSelected) {
        if (!WarningMsgOnSelected.includes(foundInSelected.id)) {
          WarningMsgOnSelected.push(l);
        }
      }
    });
  });

  const handleChangeSearchText = (event) => {
    setSearchedText(event.target.value);
  };

  const checkBoxHandler = (e) => {
    setChecked(!checked);
  };
  const handleProceed = () => {
    const payload = selectedNextModuleList.map((item) => item.id);
    const proceedSearchExpressionPayload = {
      brand_name: getBrandAndMarketCamp("brand"),
      claim_category: resetFlag
        ? ""
        : searchFlag
        ? selectedCategory
        : linkedSearchExpression?.claim_category,
      module_name: resetFlag
        ? []
        : searchFlag
        ? searchedText
          ? [searchedText]
          : []
        : linkedSearchExpression?.module_name?.length > 0
        ? linkedSearchExpression?.module_name[0]
        : [],
      asset_name: [],
      core_claim: [],
    };
    setPayloadObject({ ...proceedSearchExpressionPayload });
    getBusinessRulesModuleManager(payload, (response, err, errCode) => {
      setIsloading(true);
      if (err) {
      } else {
        const data = response.data;
        if (data) {
          setAssociatedModulecards(data);
          setShowAssociateModal(true);
         
          setIsloading(false);
          setSearchFlag(false);
          setResetFlag(false);
        }
      }
    });
  };

  const handleBackToModuleSearch = () => {
    setShowAssociateModal(false);
    /*  setSelectedNextModuleList([]);
        setSearchedText("");
        setSelectedCategory("");
         setNextModuleList([]) */
  };

  return (
    <>
      {isloading && (
        <CircularProgressBar
          isloading={isloading}
          setIsloading={setIsloading}
        />
      )}
      <div className="select-next-modal">
        <div className="header-section">
          <h2>SELECT MODULE</h2>
          <div className="header-name">
            <div className="module-name first">
              <h6>Product/Brand</h6>
              <p>{getBrandAndMarketCamp("brand")}</p>
            </div>
            <div className="module-name second">
              <h6>Campaign</h6>
              <p>{getBrandAndMarketCamp("campaign")}</p>
            </div>
            <div className="module-name third">
              <h6>Market</h6>
              <p>{getBrandAndMarketCamp("market")}</p>
            </div>
          </div>
        </div>
        <div className="select-next-module-section d-flex">
          <TextField
            id="outlined-basic"
            fullWidth
            label="Module ID/Module Name"
            variant="outlined"
            size="small"
            // value={searchedText}
            className=""
            style={{
              fontSize: "12px",
              maxWidth: "417px",
            }}
            value={searchedText}
            onChange={handleChangeSearchText}
            onKeyUp={handleEnterKeypress}
          />
          <FormControl
            fullWidth
            size="small"
            className="next-module-categories-dropdown"
            style={{
              maxWidth: "296px",
            }}
          >
            <InputLabel id="Categories-label">Categories</InputLabel>
            <Select
              labelId="Categories-label"
              id="Categories"
              MenuProps={{ PaperProps: { sx: { maxHeight: 350 } } }}
              label="Categories"
              value={selectedCategory}
              onChange={handleChangeCategory}
            >
              {nextModuleCategoryList &&
                nextModuleCategoryList?.map((item, index) => (
                  <MenuItem value={item.claimCategory} key={index}>
                    {item.claimCategory}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <button
            className="btn next-module-search-btn"
            type="button"
            style={{ maxWidth: "106px" }}
            onClick={getModulesCardDetails}
          >
            SEARCH
          </button>
          <button
            className="btn btn-default next-module-reset-btn"
            type="button"
            onClick={() => resetSearchResult()}
            disabled={
              searchedText !== "" || selectedCategory !== "" ? false : true
            }
          >
            RESET
          </button>
        </div>
        <p className="search-result">
          <span>All ({nextModuleList.length})</span> <hr />
          <span
            className={`${
              selectedNextModuleList.length > 0
                ? "checkbox-enabled"
                : "checkbox-disabled"
            }`}
          >
            <input
              type="checkbox"
              className="next-module-checkbox"
              checked={checked}
              onChange={(e) => checkBoxHandler(e)}
            />
            <span className="selected-only">
              Show Selected Only (
              {selectedNextModuleList.length > 9
                ? `${selectedNextModuleList.length}`
                : selectedNextModuleList.length === 0
                ? 0
                : `0${selectedNextModuleList.length}`}
              )
            </span>
          </span>
        </p>
        {closeWarningFlag && (
          <p className="editWarning">
            <span>
              Deselecting previously chosen modules will result in loss of
              associated business rules
            </span>
            <img
              src={CrossIcon}
              alt="CrossIcon"
              className="closeWarning"
              onClick={() => {
                //  setSelectedCardCaution(false);
                setCloseWarningFlag(false);
              }}
            />
          </p>
        )}
        <div className={`select-next-module-container customScrollBar ${closeWarningFlag ? 'selected-next-module' : 'deselected-next-module'}`}>
          <div className="row">
            {!checked
              ? nextModuleList &&
                nextModuleList.map((items, index) => {
                  return (
                    <div className="col-md-4 next-card" key={index}>
                      <NextModuleGenericCard
                        items={items}
                        selectedCardHandler={selectedCardHandler}
                        selectedNextModuleList={selectedNextModuleList}
                        checked={checked}
                      />
                    </div>
                  );
                })
              : selectedNextModuleList &&
                selectedNextModuleList.map((items, index) => {
                  return (
                    <div className="col-md-4 next-card" key={index}>
                      <NextModuleGenericCard
                        items={items}
                        selectedCardHandler={selectedCardHandler}
                        selectedNextModuleList={selectedNextModuleList}
                        checked={checked}
                      />
                    </div>
                  );
                })}
          </div>
        </div>
        <div className="footer">
          <div className="row footer-module-content">
            <div className="col-md-7 conflict-detected">
              {WarningMsgOnSelected?.length > 0
                ? `${WarningMsgOnSelected.length} Conflict detected. This can result in Compliance Issue.`
                : ""}
            </div>
            <div className="col-md-5 footer-content">
              <button
                className="cancel-btn btn btn-default"
                onClick={() => handleSelectNextModalHide()}
              >
                CANCEL
              </button>
              <button
                className="proceed-btn btn btn-default"
                onClick={() => handleProceed()}
                disabled={selectedNextModuleList.length > 0 ? false : true}
              >
                PROCEED
              </button>
            </div>
          </div>
        </div>
      </div>
      {showAssociateModal && (
        <CustomModal
          displayModal={showAssociateModal}
          /* hideModal={() => {
                    handleSelectNextModalHide();
                }} */
          title={""}
          size="xl"
          dilogClassName="select-next-modal"
          keyboard={false}
          // openExportModal={openExportModal}
        >
          <AssociateModuleModal
            getVeevaLinkedmodules={props.getVeevaLinkedmodules}
            slideID={props.slideID}
            payloadObject={payloadObject}
            associatedModulecards={associatedModulecards}
            handleBackToModuleSearch={handleBackToModuleSearch}
            handleSelectNextModalHide={handleSelectNextModalHide}
            deckData={deckData}
            setShowAssociateModal={setShowAssociateModal}
            setEditModulelistFlag={setEditModulelistFlag}
            editModulelistFlag={editModulelistFlag}
            setLinkedModule={setLinkedModule}
            setLinkedMMModules={setLinkedMMModules}
          />
        </CustomModal>
      )}
    </>
  );
};

export default NextContentModuleModal;
